import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import { Table, Button,Input,Form,FormGroup,Label,Modal,ModalHeader,ModalBody,ModalFooter,FormText,Alert} from 'reactstrap'
import { connect } from 'react-redux';
import { GiHelp } from 'react-icons/gi'

class EmergencySalto extends Component {
    static displayName = EmergencySalto.displayName;

    constructor(props) {
        super(props);
        this.state = {
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            permissionFlag: true,
            accessData: [],
            accessPoints: [],
            pcidInput: "",
            accessInput: "default",
            pcidInfo: false,
            pcidName: "",
            badPCID: false,
            badAccess: false,
            addMessage: "",
            addStatus: "",
            popoverActive: false
        }
        this.testPermission();
    }

    async testPermission() {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "/EmergencySalto"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            permissionFlag: data
        }, () => { this.getTableData(); this.getAccessPoints(); })
    }

    async getTableData() {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('EmergencySaltoData', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            accessData: data
        })
    }

    async getAccessPoints() {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('SaltoAccessPoints', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            accessPoints: data
        })
    }

    componentDidMount() {

    }

    flipInfoPCID() {
        this.setState({
            pcidInfo: !this.state.pcidInfo
        })
    }

    pcidChange(pcid) {
        this.setState({
            pcidInput: pcid
        })
        if (pcid.length == 10) {
            this.pcidLookup(pcid);
        }
    }

    async pcidLookup(pcid) {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            stuPCID: pcid
        }
        const response = await fetch('StuLookupSalto', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            pcidName: data
        })
    }

    async addAccess(e) {
        e.preventDefault();
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pcid: this.state.pcidInput,
            access: this.state.accessInput
        }
        if (toSend.pcid.length == 10 && Array.from(toSend.pcid)[0] == 'P' && toSend.access != "default") {
            const response = await fetch('AddEmergencySalto', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            })
            const data = await response.json();
            this.setState({
                addMessage: data.message,
                addStatus: !data.success
            })
            setTimeout(() => { this.setState({addStatus: false}) }, 5000)
            this.getTableData()
        }
        else {
            if (toSend.access == "default") {
                this.setState({
                    badAccess: true
                })
                setTimeout(() => {
                    this.setState({
                        badAccess: false
                    })
                }, 2500)
            }
            if (toSend.pcid.length != 10 || Array.from(toSend.pcid)[0] != 'P') {
                this.setState({
                    badPCID: true
                })
                setTimeout(() => {
                    this.setState({
                        badPCID: false
                    })
                }, 2500)
            }
        }
    }

    async revokeNow(pk) {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pk: pk
        }
        const response = await fetch('RevokeEmergencySalto', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.getTableData()
    }

    togglePopover() {
        this.setState({
            popoverActive: !this.state.popoverActive
        })
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        return (<div>
            <Modal isOpen={this.state.pcidInfo} >
                <ModalHeader>
                    What is a PCID?
                </ModalHeader>
                <ModalBody>
                    A People Code ID, or PCID, is the identifier that all employees and students are given when using College information systems. Each PCID is unique to the individual.<p />
                    A student's PCID is commonly found in the raw ID form, as a series of nine numbers. This can be found in Self-Service beneath the student's name in the Advisee Management search, or on the student's ID card itself.<p />
                    In both cases, you must preface this numerical string with a letter "P" to turn this ID number into a valid PCID.<p />
                    For example, <strong><span style={{ color: "#86d3ff" }}>P123456789</span></strong> would represent a valid PCID. Note that P123456789 is currently not used in the system.
                </ModalBody>
                <ModalFooter>
                    <Button onClick={this.flipInfoPCID.bind(this)}>Got it</Button>
                </ModalFooter>
            </Modal>
            <Form className="d-flex">
                <FormGroup>
                    <Label>PCID</Label>
                    <Input type="text" value={this.state.pcidInput} onChange={(e) => { this.pcidChange(e.target.value) }} invalid={this.state.badPCID} />
                    {this.state.pcidName != "" && <div><FormText>{this.state.pcidName.stuName}</FormText><br /></div> }
                    <a href="#" onClick={(e) => { this.flipInfoPCID(); e.preventDefault() }}><GiHelp /></a>&ensp;&ensp;
                </FormGroup>
                &ensp;
                <FormGroup>
                    <Label>Access Point</Label>
                    <Input type="select" value={this.state.accessInput} onChange={(e) => this.setState({ accessInput: e.target.value })} invalid={this.state.badAccess}>
                        <option disabled value="default">Select</option>
                        {this.state.accessPoints.map(item => (
                            <option value={item.access}>{item.access}</option>
                        ))}
                    </Input>
                </FormGroup>
                &ensp;
                <Button outline color="success" onClick={(e) => this.addAccess(e)}>Go</Button>
                &ensp;
                {this.state.addStatus && < Alert color="danger">{this.state.addMessage}</Alert>}
            </Form>
            <br />
            <Table>
                <thead>
                    <tr>
                        <th>PCID</th>
                        <th>Name</th>
                        <th>Access Point</th>
                        <th>Expires At</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.accessData.map(item => (
                        <tr>
                            <td>{item.pcid}</td>
                            <td>{item.name}</td>
                            <td>{item.accesspoint}</td>
                            <td>{item.expiration}</td>
                            <td><Button outline color="danger" onClick={() => this.revokeNow(item.pk)}>Revoke Now</Button></td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>);
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(EmergencySalto);